// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.all-players-table-container {
  margin-top: 20px;
  background: var(--bg-card);
  border-radius: var(--radius-md);
  padding: 20px;
  border: 1px solid var(--border-primary);
  box-shadow: var(--shadow-md);
}

.all-players-title {
  color: var(--text-primary);
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 15px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.all-players-title::before {
  content: "👥";
  font-size: 20px;
}

.all-players-table-wrapper {
  overflow-x: auto;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-primary);
}

.all-players-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--bg-card);
  color: var(--text-primary);
  font-size: 14px;
}

.all-players-table thead {
  background: var(--bg-tertiary);
}

.all-players-table th {
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  color: var(--text-primary);
  border-bottom: 2px solid var(--border-secondary);
  white-space: nowrap;
}

.all-players-table td {
  padding: 12px 8px;
  border-bottom: 1px solid var(--border-primary);
  vertical-align: middle;
}

.all-players-table tbody tr:hover {
  background: var(--bg-tertiary);
}

.all-players-table tbody tr:last-child td {
  border-bottom: none;
}

/* Position cell */
.position-cell {
  text-align: center;
  width: 80px;
}

.position-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border-radius: 50%;
  font-weight: 600;
  font-size: 12px;
}

/* Name and tier cell */
.name-tier-cell {
  min-width: 170px;
}

.player-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.player-name {
  font-weight: 500;
  color: var(--text-primary);
  font-size: 14px;
}

.player-details {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.world-ranking {
  color: #22c55e;
  font-weight: 600;
  background: rgba(34, 197, 94, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.tier-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  width: fit-content;
}

.tier-badge.tier-a {
  background: #fbbf24;
  color: #000;
}

.tier-badge.tier-b {
  background: #3b82f6;
  color: #fff;
}

.tier-badge.tier-c {
  background: #f97316;
  color: #fff;
}

.tier-badge.tier-d {
  background: #ef4444;
  color: #fff;
}

/* Username cell */
.username-cell {
  min-width: 120px;
}

.username {
  color: var(--text-secondary);
  font-size: 14px;
}

/* Score cell */
.score-cell {
  text-align: center;
  min-width: 100px;
}

.total-score {
  font-weight: 600;
  color: #60a5fa;
  font-size: 16px;
}

/* Skin cell */
.skin-cell {
  text-align: center;
  min-width: 100px;
}

.skin-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.skin-count {
  font-weight: 600;
  color: #4ade80;
  font-size: 16px;
}

.skin-prize-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
}

.skin-prize {
  font-weight: 600;
  color: #10b981;
  font-size: 14px;
}

.skin-percentage {
  font-size: 12px;
  color: #888;
}

/* Saw-off cell */
.sawoff-cell {
  text-align: center;
  min-width: 100px;
}

.sawoff-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.sawoff-prize {
  font-weight: 600;
  color: #f59e0b;
  font-size: 14px;
}

.sawoff-count {
  font-weight: 600;
  color: #f59e0b;
  font-size: 16px;
}

/* Skin details cell */
.skin-details-cell {
  text-align: center;
  min-width: 110px;
}

.skin-details-container {
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  align-items: center;
}

.skin-detail-badge {
  display: block;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: #000;
  min-width: 40px;
  text-align: center;
  margin-bottom: 2px;
}

/* Saw-off details cell */
.sawoff-details-cell {
  text-align: center;
  min-width: 110px;
}

.sawoff-details-container {
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  align-items: center;
}

.sawoff-detail-badge {
  display: block;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: #000;
  min-width: 40px;
  text-align: center;
  margin-bottom: 2px;
}

/* Color coding for different skin types - COMPLETED ROUNDS ONLY */
.skin-detail-albatross,
.sawoff-detail-albatross {
  background: #ef4444; /* Red for Albatross */
}

.skin-detail-eagle,
.sawoff-detail-eagle {
  background: #fbbf24; /* Yellow for Eagle */
}

.skin-detail-birdie,
.sawoff-detail-birdie {
  background: #10b981; /* Green for Birdie */
}

/* Current/Ongoing round - always blue regardless of type */
.skin-detail-current,
.sawoff-detail-current {
  background: #3b82f6; /* Blue for current round */
}

.skin-detail-bogey,
.sawoff-detail-bogey {
  background: #f59e0b; /* Orange for Bogey */
}

.skin-detail-double,
.sawoff-detail-double {
  background: #ef4444; /* Red for Double Bogey */
}

.skin-detail-triple,
.sawoff-detail-triple {
  background: #dc2626; /* Dark Red for Triple Bogey */
}

.skin-detail-unknown,
.sawoff-detail-unknown {
  background: #6b7280; /* Gray for Unknown */
}

/* Fallback for any other types */
.skin-detail-badge:not([class*="skin-detail-albatross"]):not([class*="skin-detail-eagle"]):not([class*="skin-detail-birdie"]):not([class*="skin-detail-bogey"]):not([class*="skin-detail-double"]):not([class*="skin-detail-triple"]):not([class*="skin-detail-unknown"]):not([class*="skin-detail-current"]),
.sawoff-detail-badge:not([class*="sawoff-detail-albatross"]):not([class*="sawoff-detail-eagle"]):not([class*="sawoff-detail-birdie"]):not([class*="sawoff-detail-bogey"]):not([class*="sawoff-detail-double"]):not([class*="sawoff-detail-triple"]):not([class*="sawoff-detail-unknown"]):not([class*="sawoff-detail-current"]) {
  background: #6b7280; /* Gray fallback */
}

/* Empty state */
.empty-state.no-players {
  text-align: center;
  padding: 40px 20px;
  color: #888;
}

.empty-state.no-players p {
  margin: 0;
  font-size: 14px;
}

/* Responsive design */
@media (max-width: 768px) {
  .all-players-table-container {
    padding: 15px;
  }
  
  .all-players-table th,
  .all-players-table td {
    padding: 8px 12px;
    font-size: 13px;
  }
  
  .player-info {
    gap: 2px;
  }
  
  .player-name {
    font-size: 13px;
  }
  
  .player-details {
    gap: 6px;
    font-size: 11px;
  }
  
  .world-ranking {
    padding: 1px 4px;
    font-size: 10px;
  }
  
  .tier-badge {
    font-size: 10px;
    padding: 1px 6px;
  }
  
  .username {
    font-size: 12px;
  }
  
  .total-score {
    font-size: 14px;
  }
  
  .skin-count,
  .sawoff-count {
    font-size: 14px;
  }
  
  .skin-detail-badge,
  .sawoff-detail-badge {
    font-size: 10px;
    padding: 2px 6px;
    min-width: 32px;
  }
  
  /* Responsive button sizing */
  .remove-player-btn {
    min-width: 70px;
    height: 28px;
    font-size: 11px;
    padding: 4px 8px;
  }
  
  .action-cell {
    width: 80px;
    min-width: 80px;
    padding: 6px 8px;
  }
}

@media (max-width: 480px) {
  .all-players-table th,
  .all-players-table td {
    padding: 6px 8px;
    font-size: 12px;
  }
  
  .position-cell {
    width: 60px;
  }
  
  .name-tier-cell {
    min-width: 140px;
  }
  
  .username-cell,
  .score-cell,
  .skin-cell,
  .sawoff-cell,
  .skin-details-cell,
  .sawoff-details-cell {
    min-width: 70px;
  }
}

/* Remove Player Button Styles */
.remove-player-btn {
  background: #dc3545;
  color: white;
  border: none;
  padding: 6px ;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-width: 70px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
}

.remove-player-btn:hover:not(:disabled) {
  background: #c82333;
  transform: translateY(-1px);
}

.remove-player-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.remove-player-btn.removing {
  background: #ffc107;
  color: #000;
  animation: pulse 1s infinite;
}

.remove-player-btn.disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.7; }
  100% { opacity: 1; }
}

.action-cell {
  text-align: center;
  padding: 8px 12px;
  white-space: nowrap;
  width: 100px;
  min-width: 100px;
}`, "",{"version":3,"sources":["webpack://./src/components/TournamentLiveEvents/components/AllPlayersTable.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;;EAEE,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;;EAEE,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA;;EAEE,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA,2DAA2D;AAC3D;;EAEE,mBAAmB,EAAE,2BAA2B;AAClD;;AAEA;;EAEE,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA;;EAEE,mBAAmB,EAAE,yBAAyB;AAChD;;AAEA;;EAEE,mBAAmB,EAAE,8BAA8B;AACrD;;AAEA;;EAEE,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA,iCAAiC;AACjC;;EAEE,mBAAmB,EAAE,kBAAkB;AACzC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA,6BAA6B;EAC7B;IACE,eAAe;IACf,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;;;IAME,eAAe;EACjB;AACF;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".all-players-table-container {\n  margin-top: 20px;\n  background: var(--bg-card);\n  border-radius: var(--radius-md);\n  padding: 20px;\n  border: 1px solid var(--border-primary);\n  box-shadow: var(--shadow-md);\n}\n\n.all-players-title {\n  color: var(--text-primary);\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 15px 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.all-players-title::before {\n  content: \"👥\";\n  font-size: 20px;\n}\n\n.all-players-table-wrapper {\n  overflow-x: auto;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-primary);\n}\n\n.all-players-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: var(--bg-card);\n  color: var(--text-primary);\n  font-size: 14px;\n}\n\n.all-players-table thead {\n  background: var(--bg-tertiary);\n}\n\n.all-players-table th {\n  padding: 12px 8px;\n  text-align: left;\n  font-weight: 600;\n  color: var(--text-primary);\n  border-bottom: 2px solid var(--border-secondary);\n  white-space: nowrap;\n}\n\n.all-players-table td {\n  padding: 12px 8px;\n  border-bottom: 1px solid var(--border-primary);\n  vertical-align: middle;\n}\n\n.all-players-table tbody tr:hover {\n  background: var(--bg-tertiary);\n}\n\n.all-players-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Position cell */\n.position-cell {\n  text-align: center;\n  width: 80px;\n}\n\n.position-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border-radius: 50%;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n/* Name and tier cell */\n.name-tier-cell {\n  min-width: 170px;\n}\n\n.player-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.player-name {\n  font-weight: 500;\n  color: var(--text-primary);\n  font-size: 14px;\n}\n\n.player-details {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n}\n\n.world-ranking {\n  color: #22c55e;\n  font-weight: 600;\n  background: rgba(34, 197, 94, 0.1);\n  padding: 2px 6px;\n  border-radius: 4px;\n  border: 1px solid rgba(34, 197, 94, 0.3);\n}\n\n.tier-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  width: fit-content;\n}\n\n.tier-badge.tier-a {\n  background: #fbbf24;\n  color: #000;\n}\n\n.tier-badge.tier-b {\n  background: #3b82f6;\n  color: #fff;\n}\n\n.tier-badge.tier-c {\n  background: #f97316;\n  color: #fff;\n}\n\n.tier-badge.tier-d {\n  background: #ef4444;\n  color: #fff;\n}\n\n/* Username cell */\n.username-cell {\n  min-width: 120px;\n}\n\n.username {\n  color: var(--text-secondary);\n  font-size: 14px;\n}\n\n/* Score cell */\n.score-cell {\n  text-align: center;\n  min-width: 100px;\n}\n\n.total-score {\n  font-weight: 600;\n  color: #60a5fa;\n  font-size: 16px;\n}\n\n/* Skin cell */\n.skin-cell {\n  text-align: center;\n  min-width: 100px;\n}\n\n.skin-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n\n.skin-count {\n  font-weight: 600;\n  color: #4ade80;\n  font-size: 16px;\n}\n\n.skin-prize-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1px;\n}\n\n.skin-prize {\n  font-weight: 600;\n  color: #10b981;\n  font-size: 14px;\n}\n\n.skin-percentage {\n  font-size: 12px;\n  color: #888;\n}\n\n/* Saw-off cell */\n.sawoff-cell {\n  text-align: center;\n  min-width: 100px;\n}\n\n.sawoff-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n\n.sawoff-prize {\n  font-weight: 600;\n  color: #f59e0b;\n  font-size: 14px;\n}\n\n.sawoff-count {\n  font-weight: 600;\n  color: #f59e0b;\n  font-size: 16px;\n}\n\n/* Skin details cell */\n.skin-details-cell {\n  text-align: center;\n  min-width: 110px;\n}\n\n.skin-details-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  justify-content: center;\n  align-items: center;\n}\n\n.skin-detail-badge {\n  display: block;\n  padding: 4px 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #000;\n  min-width: 40px;\n  text-align: center;\n  margin-bottom: 2px;\n}\n\n/* Saw-off details cell */\n.sawoff-details-cell {\n  text-align: center;\n  min-width: 110px;\n}\n\n.sawoff-details-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  justify-content: center;\n  align-items: center;\n}\n\n.sawoff-detail-badge {\n  display: block;\n  padding: 4px 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #000;\n  min-width: 40px;\n  text-align: center;\n  margin-bottom: 2px;\n}\n\n/* Color coding for different skin types - COMPLETED ROUNDS ONLY */\n.skin-detail-albatross,\n.sawoff-detail-albatross {\n  background: #ef4444; /* Red for Albatross */\n}\n\n.skin-detail-eagle,\n.sawoff-detail-eagle {\n  background: #fbbf24; /* Yellow for Eagle */\n}\n\n.skin-detail-birdie,\n.sawoff-detail-birdie {\n  background: #10b981; /* Green for Birdie */\n}\n\n/* Current/Ongoing round - always blue regardless of type */\n.skin-detail-current,\n.sawoff-detail-current {\n  background: #3b82f6; /* Blue for current round */\n}\n\n.skin-detail-bogey,\n.sawoff-detail-bogey {\n  background: #f59e0b; /* Orange for Bogey */\n}\n\n.skin-detail-double,\n.sawoff-detail-double {\n  background: #ef4444; /* Red for Double Bogey */\n}\n\n.skin-detail-triple,\n.sawoff-detail-triple {\n  background: #dc2626; /* Dark Red for Triple Bogey */\n}\n\n.skin-detail-unknown,\n.sawoff-detail-unknown {\n  background: #6b7280; /* Gray for Unknown */\n}\n\n/* Fallback for any other types */\n.skin-detail-badge:not([class*=\"skin-detail-albatross\"]):not([class*=\"skin-detail-eagle\"]):not([class*=\"skin-detail-birdie\"]):not([class*=\"skin-detail-bogey\"]):not([class*=\"skin-detail-double\"]):not([class*=\"skin-detail-triple\"]):not([class*=\"skin-detail-unknown\"]):not([class*=\"skin-detail-current\"]),\n.sawoff-detail-badge:not([class*=\"sawoff-detail-albatross\"]):not([class*=\"sawoff-detail-eagle\"]):not([class*=\"sawoff-detail-birdie\"]):not([class*=\"sawoff-detail-bogey\"]):not([class*=\"sawoff-detail-double\"]):not([class*=\"sawoff-detail-triple\"]):not([class*=\"sawoff-detail-unknown\"]):not([class*=\"sawoff-detail-current\"]) {\n  background: #6b7280; /* Gray fallback */\n}\n\n/* Empty state */\n.empty-state.no-players {\n  text-align: center;\n  padding: 40px 20px;\n  color: #888;\n}\n\n.empty-state.no-players p {\n  margin: 0;\n  font-size: 14px;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .all-players-table-container {\n    padding: 15px;\n  }\n  \n  .all-players-table th,\n  .all-players-table td {\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n  \n  .player-info {\n    gap: 2px;\n  }\n  \n  .player-name {\n    font-size: 13px;\n  }\n  \n  .player-details {\n    gap: 6px;\n    font-size: 11px;\n  }\n  \n  .world-ranking {\n    padding: 1px 4px;\n    font-size: 10px;\n  }\n  \n  .tier-badge {\n    font-size: 10px;\n    padding: 1px 6px;\n  }\n  \n  .username {\n    font-size: 12px;\n  }\n  \n  .total-score {\n    font-size: 14px;\n  }\n  \n  .skin-count,\n  .sawoff-count {\n    font-size: 14px;\n  }\n  \n  .skin-detail-badge,\n  .sawoff-detail-badge {\n    font-size: 10px;\n    padding: 2px 6px;\n    min-width: 32px;\n  }\n  \n  /* Responsive button sizing */\n  .remove-player-btn {\n    min-width: 70px;\n    height: 28px;\n    font-size: 11px;\n    padding: 4px 8px;\n  }\n  \n  .action-cell {\n    width: 80px;\n    min-width: 80px;\n    padding: 6px 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .all-players-table th,\n  .all-players-table td {\n    padding: 6px 8px;\n    font-size: 12px;\n  }\n  \n  .position-cell {\n    width: 60px;\n  }\n  \n  .name-tier-cell {\n    min-width: 140px;\n  }\n  \n  .username-cell,\n  .score-cell,\n  .skin-cell,\n  .sawoff-cell,\n  .skin-details-cell,\n  .sawoff-details-cell {\n    min-width: 70px;\n  }\n}\n\n/* Remove Player Button Styles */\n.remove-player-btn {\n  background: #dc3545;\n  color: white;\n  border: none;\n  padding: 6px ;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  min-width: 70px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n}\n\n.remove-player-btn:hover:not(:disabled) {\n  background: #c82333;\n  transform: translateY(-1px);\n}\n\n.remove-player-btn:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.remove-player-btn.removing {\n  background: #ffc107;\n  color: #000;\n  animation: pulse 1s infinite;\n}\n\n.remove-player-btn.disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n@keyframes pulse {\n  0% { opacity: 1; }\n  50% { opacity: 0.7; }\n  100% { opacity: 1; }\n}\n\n.action-cell {\n  text-align: center;\n  padding: 8px 12px;\n  white-space: nowrap;\n  width: 100px;\n  min-width: 100px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
